import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea, Text } from "@mantine/core";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useAppAction, useAppSelector } from "../../hooks/redux.js";
import { getMarkers, selectMarker, getSelectedMarkerId } from "../../reducers/markerReducer.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
import { PrimaryPanel } from "../../components/SidePanel.js";
import { MarkerListHeader } from "./MarkerListHeader.js";
import { MarkerListItem } from "./MarkerListItem.js";
export const MarkerList = ({ onClose }) => {
    const captureEvent = useCaptureEvent();
    const markers = useAppSelector(getMarkers);
    const selectedMarker = useAppSelector(getSelectedMarkerId);
    const changeMarker = useAppAction(selectMarker);
    const handleSelectMarker = useCallback((id) => {
        if (id) {
            captureEvent(Event.SelectMarker, { id });
            changeMarker(id);
        }
    }, [changeMarker, captureEvent]);
    return (_jsxs(PrimaryPanel, { children: [_jsx(MarkerListHeader, { onClose: onClose }), _jsxs(ScrollArea, { flex: "1", mih: 0, children: [markers.length === 0 && (_jsx(Text, { fz: 14, fs: "italic", c: "dimmed", children: _jsx(FormattedMessage, { id: "text.noMarkers", defaultMessage: "No markers" }) })), markers.map((marker) => {
                        const selected = marker.id === selectedMarker;
                        return (_jsx(MarkerListItem, { marker: marker, selected: selected, onClick: () => { handleSelectMarker(marker.id); } }, marker.id));
                    })] })] }));
};
